import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.button = this.buttonTarget
    this.menu = this.menuTarget
    this.isOpen = false
    this.boundHandleDocumentClick = this.handleDocumentClick.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.boundHandleViewportChange = this.handleViewportChange.bind(this)

    this.placeholder = document.createComment("floating-menu")
    this.menu.after(this.placeholder)
    document.body.appendChild(this.menu)
    this.menu.classList.add("hidden")
    this.menu.style.position = "fixed"
  }

  disconnect() {
    this.close()

    if (this.placeholder?.parentNode) {
      this.placeholder.parentNode.replaceChild(this.menu, this.placeholder)
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.menu.classList.remove("hidden")
    this.menu.style.visibility = "hidden"
    this.positionMenu()
    this.menu.style.visibility = ""
    this.button.setAttribute("aria-expanded", "true")

    document.addEventListener("click", this.boundHandleDocumentClick)
    document.addEventListener("keydown", this.boundHandleKeydown)
    window.addEventListener("resize", this.boundHandleViewportChange)
    window.addEventListener("scroll", this.boundHandleViewportChange, true)
  }

  close() {
    if (!this.isOpen) return

    this.isOpen = false
    this.menu.classList.add("hidden")
    this.menu.style.visibility = ""
    this.button.setAttribute("aria-expanded", "false")

    document.removeEventListener("click", this.boundHandleDocumentClick)
    document.removeEventListener("keydown", this.boundHandleKeydown)
    window.removeEventListener("resize", this.boundHandleViewportChange)
    window.removeEventListener("scroll", this.boundHandleViewportChange, true)
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target) || this.menu.contains(event.target)) return

    this.close()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
      this.button.focus()
    }
  }

  handleViewportChange() {
    if (this.isOpen) {
      this.positionMenu()
    }
  }

  positionMenu() {
    const buttonRect = this.button.getBoundingClientRect()
    const menuRect = this.menu.getBoundingClientRect()
    const gutter = 12
    const offset = 8

    let left = buttonRect.right - menuRect.width
    left = Math.max(gutter, Math.min(left, window.innerWidth - menuRect.width - gutter))

    const spaceBelow = window.innerHeight - buttonRect.bottom - gutter
    const spaceAbove = buttonRect.top - gutter

    let top
    if (spaceBelow >= menuRect.height || spaceBelow >= spaceAbove) {
      top = Math.min(buttonRect.bottom + offset, window.innerHeight - menuRect.height - gutter)
    } else {
      top = Math.max(gutter, buttonRect.top - menuRect.height - offset)
    }

    this.menu.style.left = `${left}px`
    this.menu.style.top = `${top}px`
  }
}
